import React from 'react';
import ReactDOM from 'react-dom/client';
import { Modal } from 'antd';
import { Provider } from 'react-redux';
import ButtonIconGhostMedium from '../ButtonIconGhost/ButtonIconGhostMedium';
import { Icon } from '../../icon/icon';
import store from '../../../store/root.reducer';
import { cn } from '../../../utils/string/cn.utils';

let modalInstance = null;

/**
 * Hàm mở modal - có thể gọi từ bất kỳ đâu
 * @param {Object} config - Cấu hình modal (title, content, onOk, onCancel, v.v.)
 * @returns {Object} Object chứa các method destroy và update
 */
export const openModal = config => {
  // Destroy modal cũ nếu tồn tại
  if (modalInstance) {
    modalInstance.destroy();
  }

  const div = document.createElement('div');
  document.body.appendChild(div);

  const root = ReactDOM.createRoot(div);
  let currentConfig = config;

  const destroy = () => {
    if (currentConfig?.afterClose) {
      currentConfig.afterClose();
    }
    root.unmount();
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
    modalInstance = null;
  };

  const render = props => {
    const {
      content,
      onCancel,
      onOk,
      title,
      closable,
      classNames,
      onClose,
      ...restProps
    } = props;

    const handleCancel = e => {
      if (onCancel) {
        onCancel(e);
      }
      destroy();
    };

    const handleOk = e => {
      const result = onOk ? onOk(e) : undefined;
      // Nếu onOk trả về Promise, chờ xong mới đóng
      if (result instanceof Promise) {
        result.then(() => destroy()).catch(() => {});
      } else {
        destroy();
      }
    };

    root.render(
      <Provider store={store}>
        <Modal
          open={true}
          onCancel={handleCancel}
          onOk={handleOk}
          {...restProps}
          classNames={{
            content: cn(
              '!p-0 !m-[0px] !rounded-[24px] overflow-hidden',
              classNames?.content
            ),
            header: cn(
              // 'm-[0px] flex items-start justify-start self-stretch px-[24px] pt-[32px] pb-[16px]',
              classNames?.header
            ),
            body: cn(
              // 'py-[16px] px-[24px] gap-[24px] flex items-center justify-center flex-col m-[0px]',
              classNames?.body
            ),
            footer: cn('m-[0px]', classNames?.footer),
          }}
          closable={false}
          title={
            <>
              {title}
              {closable !== false && (
                <ButtonIconGhostMedium
                  icon={<Icon.ICClose />}
                  onClick={() => {
                    onClose?.();
                    destroy();
                  }}
                  className={cn(
                    'absolute top-24 right-24',
                    classNames.iconClose
                  )}
                />
              )}
            </>
          }
        >
          {content}
        </Modal>
      </Provider>
    );
  };

  render(config);

  modalInstance = {
    destroy,
    update: newConfig => {
      render({ ...config, ...newConfig });
    },
  };

  return modalInstance;
};
